import wifi from "assets/images/wifi.svg";
import charger from "assets/images/charger.svg";
import snacks from "assets/images/snacks.svg";
import newspaper from "assets/images/newspaper.svg";
import water from "assets/images/water.svg";
export const FacilitiesData = [
  {
    id: 1,
    img: wifi,
    name: "Wifi",
  },
  {
    id: 2,
    img: charger,
    name: "Charger",
  },
  {
    id: 3,
    img: snacks,
    name: "Snacks",
  },
  {
    id: 4,
    img: newspaper,
    name: "Newspaper",
  },
  {
    id: 5,
    img: water,
    name: "Water",
  },
];
export const onewayRulePoint = [
  {
    id:1,
    label:"Regularly audited cars",
  },
  {
    id:2,
    label:"24X7 on - road assistance ",
  },
  {
    id:3,
    label:"Real time tracking",
  }
]
export const rulePoints = [
  {
    id:1,
    label:"Excludes toll costs, parking, & intercity tas"
  },
  {
    id:2,
    label: "₹150/hr will be charged for additional hours"
  },
  {
    id:3,
    label:" ₹20/km will be charged for extra km"
  },
  {
    id:4,
    label: "Driver allowanace per 24 hours- ₹265"
  },
  {
    id:5,
    label:" Night time allowance (11:00 PM - 06:00 AM) -₹220/night"
  },
  {
    id:6,
    label:" Extra fare may apply if you  don’t end trip at Unkown"
  }
] 
export const fareData = (trip) => {
  return [
    {
      id:1,
      heading: "Base Fare",
      subHeading:`${trip?.packageDistance}km ${trip?.days} Day`,
      amount:trip?.baseFare
    },
    {
      id:2,
      heading:"Fare for remaining km",
      amount:trip?.remainingDistanceFare
    },
    {
      id:3,
      heading:"Taxes and fees",
      amount:trip?.nightAllowance
    }
  
  ]
} 